import axios from "./interceptor";
import { BASE_API, AUDITSX_BASE_API } from "../types/api-endpoints";

import {
  AUTH_ID_TOKEN,
  AUTH_REFRESH_TOKEN,
  USER_PROFILE,
} from "../types/micellinous-constants";

async function getHeadersAuth() {
  const userDetails = JSON.parse(localStorage.getItem(USER_PROFILE));

  const idToken = await AUTH_ID_TOKEN();
  return {
    "Content-Type": "application/json",
    Authorization: idToken,
    "x-username": userDetails.userName,
    refresh: AUTH_REFRESH_TOKEN(),
  };
}

async function getHeadersMultiPart() {
  const userDetails = JSON.parse(localStorage.getItem(USER_PROFILE));
  const idToken = await AUTH_ID_TOKEN();
  return {
    "Content-Type": "multipart/form-data",
    Authorization: idToken,
    "x-username": userDetails.userName,
    refresh: AUTH_REFRESH_TOKEN(),
  };
}

async function getHeaders(type) {
  if (type) {
    return {
      "Content-Type": type,
    };
  } else {
    return {
      "Content-Type": "application/json",
    };
  }
}

// function to call the register api for new user account on website

export const Signup = async function (
  fullName,
  username,
  password,
  gender,
  dob
) {
  const headers = await getHeaders();

  const body = {
    userName: username,
    password,
    gender,
    dob,
    fullName,
  };

  //   send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/auth/register`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the login api for new user account on website

export const LoginAdminUser = async function (username, password) {
  const headers = await getHeaders();

  const body = {
    userName: username,
    password: password,
  };

  //   send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/admin/login`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

export const LoginUser = async function (username, password) {
  const headers = await getHeaders();

  const body = {
    userName: username,
    password: password,
  };

  //   send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/auth/login`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the VerifyEmail API when a user attempts to register
export const VerifyUserEmail = async function (username, verificationCode) {
  const headers = await getHeaders();

  const body = {
    userName: username,
    code: verificationCode,
  };

  //   send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/auth/verifyEmail`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the resendVerificationCode API when a user clicks the resend link
export const resendVerificationCode = async function (username) {
  const headers = await getHeaders();

  const body = {
    userName: username,
  };

  //   send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/auth/verifyEmail/resend`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the ForgotPassword API when a user attempts to forgot password
export const forgotPassword = async function (username) {
  const headers = await getHeaders();
  const body = {
    userName: username,
  };
  return await axios
    .post(`${BASE_API}/v1/auth/forgotPassword`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the verifyForgotPassword API when a
export const verifyForgotPassword = async function (
  username,
  token,
  newPassword
) {
  const headers = await getHeaders();
  const body = {
    userName: username,
    token: token,
    newPassword: newPassword,
  };

  return await axios
    .post(`${BASE_API}/v1/auth/verifyForgotPassword`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the checkFirstUser API when a user clicks the resend link
export const checkFirstUser = async function () {
  const headers = await getHeaders();
  return await axios
    .get(`${BASE_API}/v1/user/users`, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the getCurrentUserDetailsAPI if the user is logged in or after the user logs in
export const getCurrentUserDetails = async function (userId) {
  const headers = await getHeadersAuth();
  return await axios
    .get(`${BASE_API}/v1/user/${userId}`, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to get user groups
export const getUserGroups = async function () {
  const headers = await getHeadersAuth();
  return await axios
    .get(`${BASE_API}/v1/userGroup`, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to get user groups subfunctions
export const getUserGroupById = async function (id) {
  const headers = await getHeadersAuth();
  return await axios
    .get(`${BASE_API}/v1/userGroup/${id}`, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to search users via email or name
export const searchUsers = async function (searchQuery) {
  const headers = await getHeadersAuth();

  return await axios
    .get(`${BASE_API}/v1/user/search?searchQuery=${searchQuery}`, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to get users
export const getUsers = async function (limit, user_id = null) {
  const headers = await getHeadersAuth();

  if (!user_id) {
    return await axios
      .get(`${BASE_API}/v1/user/allUsers?limit=${limit}`, { headers })
      .then((res) => res)
      .catch((err) => {
        return err;
      });
  } else {
    return await axios
      .get(`${BASE_API}/v1/user/allUsers?limit=${limit}&user_id=${user_id}`, {
        headers,
      })
      .then((res) => res)
      .catch((err) => {
        return err;
      });
  }
};

// function to get users
export const getUserById = async function (user_id) {
  const headers = await getHeadersAuth();

  return await axios
    .get(`${BASE_API}/v1/user/${user_id}`, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to get users userName by list
export const getUserNames = async function (user_ids) {
  const headers = await getHeadersAuth();

  return await axios
    .post(`${BASE_API}/v1/user/getUserNames`, user_ids, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to search users via email or name
export const deleteUser = async function (user_id) {
  const headers = await getHeadersAuth();

  return await axios
    .delete(`${BASE_API}/v1/user?user_id=${user_id}`, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the updateUserGroup API when save is clicked in Roles component
export const UpdateUserGroupAccess = async function (mainFunctionObj) {
  const headers = await getHeadersAuth();

  const body = {
    mainFunctionObj,
  };

  //   send the request to the api and console log the response/error
  return await axios
    .put(`${BASE_API}/v1/userGroup`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the deleteUserGroup API when save is clicked in UserGroup component
export const deleteUserGroup = async function (userGroupID) {
  const headers = await getHeadersAuth();

  //   send the request to the api and console log the response/error
  return await axios
    .delete(`${BASE_API}/v1/userGroup/${userGroupID}`, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the addUser API when save is clicked in Bulk Update component
export const bulkUpdateUserGroup = async function (
  userGroupID,
  usersListForBulkUpdate
) {
  const headers = await getHeadersAuth();

  const body = {
    userGroupId: userGroupID,
    users: usersListForBulkUpdate,
  };

  //   send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/userGroup/addUser`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the createUserGroup API when save is clicked in Add UserGroup Dialog
export const addUserGroup = async function (
  userGroupName,
  type,
  isAdmin = false
) {
  const headers = await getHeadersAuth();

  const body = {
    name: userGroupName,
    type,
    isAdmin,
  };

  //send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/userGroup`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the createUserGroup API when save is clicked in Add UserGroup Dialog
export const copyUserGroup = async function (selectedUserGroupID, name) {
  const headers = await getHeadersAuth();

  const body = {
    id: selectedUserGroupID,
    name,
  };

  //send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/userGroup/copy`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the profilePicture API when a new picture is uploaded
export const uploadProfilePicture = async (file, userId) => {
  const headers = await getHeadersMultiPart();
  const body = new FormData();

  // append uploaded file to body
  body.append("uploaded_file", file);

  //send the request to the api and return the response/error

  return await axios
    .put(`${BASE_API}/v1/user/profilePicture/${userId}`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};
// function to call the updateProfile API when submitted
export const updateProfile = async (userName, values, userId) => {
  const headers = await getHeadersAuth();
  const body = {
    fullName: values.fullName,
    userName: userName,
    updatedUserName: values.updatedUsername,
  };
  return await axios
    .put(`${BASE_API}/v1/user/${userId}`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the addGroup API
export const addGroup = async (groupName, managerId) => {
  const headers = await getHeadersAuth();
  const body = {
    name: groupName,
    managerId,
    sgExists: "false",
  };
  return await axios
    .post(`${BASE_API}/v1/group`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to call the addGroup API
export const getAllGroups = async () => {
  const headers = await getHeadersAuth();

  return await axios.get(`${BASE_API}/v1/group`, {}, { headers });
};

// function to call the addGroup API
export const getGroupById = async (id) => {
  const headers = await getHeadersAuth();

  return await axios.get(`${BASE_API}/v1/group/${id}`, { headers });
};

// function to call the addSubGroup API
export const addSubGroup = async (subGroupObj) => {
  const headers = await getHeadersAuth();
  const body = subGroupObj;

  return await axios
    .post(`${BASE_API}/v1/group/add`, body, { headers })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to register admin user
export const registerAdminUser = async function (
  password,
  username,
  selectedUserGroup,
  fullName
) {
  const headers = await getHeadersAuth();

  const body = {
    password,
    userName: username,
    userGroupId: selectedUserGroup,
    fullName,
  };

  //   send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/admin/registerUser`, body, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to register admin user
export const addUserToGroup = async function (groupId, idName, userIdList) {
  const headers = await getHeadersAuth();

  const body = {
    groupId,
    idName,
    userId: userIdList,
  };

  //   send the request to the api and console log the response/error
  return await axios
    .post(`${BASE_API}/v1/group/addUser`, body, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to get users of group/subgroup
export const getUsersByGroup = async function (groupId, idName) {
  const headers = await getHeadersAuth();

  if (idName) {
    return await axios
      .get(`${BASE_API}/v1/group/getUsers/${groupId}::${idName}`, {
        headers,
      })

      .then((res) => res)
      .catch((err) => {
        return err;
      });
  } else {
    return await axios
      .get(`${BASE_API}/v1/group/getUsers/${groupId}`, { headers })

      .then((res) => res)
      .catch((err) => {
        return err;
      });
  }
};

// function to delete users from group/subgroup
export const removeUsersFromGroup = async function (userIdList) {
  const headers = await getHeadersAuth();

  const data = {
    userId: userIdList,
  };

  return await axios
    .post(`${BASE_API}/v1/group/user/delete`, data, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to delete group
export const deleteGroup = async function (groupId) {
  const headers = await getHeadersAuth();

  return await axios
    .delete(`${BASE_API}/v1/group/${groupId}`, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};
// function to delete subgroup
export const deleteSubgroup = async function (groupId, idName) {
  const headers = await getHeadersAuth();

  return await axios
    .delete(`${BASE_API}/v1/group/sg/${groupId}::${idName}`, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to verify username exists
export const verifyUsernameExists = async function (username) {
  const headers = await getHeadersAuth();

  return await axios
    .get(`${BASE_API}/v1/user/userName/${username}`, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// ==============================

// function to delete users from group/subgroup
export const resetPasswordAdmin = async function (data) {
  const headers = await getHeadersAuth();

  return await axios
    .post(`${BASE_API}/v1/admin/resetPassword`, data, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to delete users from group/subgroup
export const resetPassword = async function (data) {
  const headers = await getHeadersAuth();

  return await axios
    .post(`${BASE_API}/v1/auth/resetPassword`, data, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

export const sendSupport = async function (data) {
  const headers = await getHeaders();

  return await axios
    .post(`${BASE_API}/v1/auth/sendSupport`, data, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

export const getFacilities = async function (username) {
  const headers = await getHeadersAuth();

  return await axios
    .get(`${BASE_API}/v1/auth/getFacilities`, {
      headers,
    })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// ==== Hand Hygiene ====

function generateApiEndpoint(options) {
  const queryParams = Object.entries(options)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return queryParams;
}

// function to get getHandHygieneRecords
export const getHandHygieneRecords = async function ({
  deleted,
  from = "",
  to = "",
}) {
  const headers = await getHeadersAuth();

  const apiEndpoint = generateApiEndpoint({
    deleted: deleted,
    from: from,
    to: to,
  });

  return await axios
    .get(`${AUDITSX_BASE_API}/v1/handHygiene/getRecords?${apiEndpoint}`, {
      headers,
    })
    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

// function to create a new record for handHygiene
export const createRecordHandHygiene = async function (data) {
  const headers = await getHeadersAuth();

  return await axios
    .post(`${AUDITSX_BASE_API}/v1/handHygiene/createRecord`, data, { headers })

    .then((res) => res)
    .catch((err) => {
      return err;
    });
};

export const updateRecordHandHygiene = async (recordId, data) => {
  const headers = await getHeadersAuth();

  return await axios
    .put(`${AUDITSX_BASE_API}/v1/handHygiene/updateRecord/${recordId}`, data, {
      headers,
    })
    .then((res) => res)
    .catch((err) => err);
};

// ==== PPE ====

// function to get getPPERecords
export const getPPERecords = async function ({ deleted, from = "", to = "" }) {
  const headers = await getHeadersAuth();

  const apiEndpoint = generateApiEndpoint({
    deleted: deleted,
    from: from,
    to: to,
  });

  try {
    const response = await axios.get(
      `${AUDITSX_BASE_API}/v1/ppe/getRecords?${apiEndpoint}`,
      { headers }
    );
    console.log("API Response:", response.data);
    return response;
  } catch (err) {
    console.error("API Error:", err);
    return err;
  }
};

// function to create a new record for PPE
export const createRecordPPE = async function (data) {
  const headers = await getHeadersAuth();

  return await axios
    .post(`${AUDITSX_BASE_API}/v1/ppe/createRecord`, data, {
      headers,
    })
    .then((res) => {
      console.log("Form submitted successfully!", res.data);
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const updateRecordPPE = async function (recordId, data) {
  const headers = await getHeadersAuth();

  return await axios
    .put(`${AUDITSX_BASE_API}/v1/ppe/updateRecord/${recordId}`, data, {
      headers,
    })
    .then((res) => {
      console.log("Record updated successfully!", res.data);
      return res;
    })
    .catch((err) => {
      return err;
    });
};

//getPatient records

export const getPatientRecords = async function () {
  const headers = await getHeadersAuth();
  return await axios
    .get(`${AUDITSX_BASE_API}/v1/patients/getRecords?archived=false`, {
      headers,
    })
    .then((res) => res)
    .catch((err) => err);
};

export const createPatientRecord = async (data) => {
  const headers = await getHeadersAuth();
  return await axios
    .post(`${AUDITSX_BASE_API}/v1/patients/createRecord`, data, {
      headers,
    })
    .then((res) => res)
    .catch((err) => err);
};

export const updatePatientRecord = async (patientId, data) => {
  const headers = await getHeadersAuth();
  const url = `${AUDITSX_BASE_API}/v1/patients/updateRecord/${patientId}`;

  return await axios
    .put(url, data, { headers })
    .then((res) => res)
    .catch((err) => err);
};

// Narcotics Records Below

export const createRecordNarcotics = async function (data) {
  const headers = await getHeadersAuth();

  return await axios
    .post(`${AUDITSX_BASE_API}/v1/narcotics/createRecord`, data, {
      headers,
    })
    .then((res) => {
      console.log("Form submitted successfully!", res.data);
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getNarcoticsRecords = async function ({
  deleted,
  from = "",
  to = "",
}) {
  const headers = await getHeadersAuth();

  const apiEndpoint = generateApiEndpoint({
    deleted: deleted,
    from: from,
    to: to,
  });

  try {
    const response = await axios.get(
      `${AUDITSX_BASE_API}/v1/narcotics/getRecords?${apiEndpoint}`,
      { headers }
    );
    console.log("API Response:", response.data);
    return response;
  } catch (err) {
    console.error("API Error:", err);
    return err;
  }
};

export const updateRecordsNarcotics = async function (
  recordId,
  qualitativeData
) {
  const headers = await getHeadersAuth();

  const qualitativeEndpoint = `${AUDITSX_BASE_API}/v1/narcotics/updateRecordQualitative/${recordId}`;

  try {
    const qualitativeResponse = await axios.put(
      qualitativeEndpoint,
      qualitativeData,
      {
        headers,
      }
    );
    console.log(
      "Qualitative Record updated successfully!",
      qualitativeResponse.data
    );

    return {
      qualitative: qualitativeResponse.data,
    };
  } catch (err) {
    console.error("Error updating records:", err);
    throw err;
  }
};

// Patient Care Records Below

export const createRecordPatientCare = async function (data) {
  const headers = await getHeadersAuth();

  return await axios
    .post(`${AUDITSX_BASE_API}/v1/patientCare/createRecord`, data, {
      headers,
    })
    .then((res) => {
      console.log("Form submitted successfully!", res.data);
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getPatientCareRecords = async function ({
  deleted,
  from = "",
  to = "",
}) {
  const headers = await getHeadersAuth();

  const apiEndpoint = generateApiEndpoint({
    deleted: deleted,
    from: from,
    to: to,
  });

  try {
    const response = await axios.get(
      `${AUDITSX_BASE_API}/v1/patientCare/getRecords?${apiEndpoint}`,
      { headers }
    );
    console.log("API Response:", response.data);
    return response;
  } catch (err) {
    console.error("API Error:", err);
    return err;
  }
};

export const updateRecordPatientCare = async function (recordId, data) {
  const headers = await getHeadersAuth();

  return await axios
    .put(`${AUDITSX_BASE_API}/v1/patientCare/updateRecord/${recordId}`, data, {
      headers,
    })
    .then((res) => {
      console.log("Record updated successfully!", res.data);
      return res;
    })
    .catch((err) => {
      return err;
    });
};

// dining audit records below
export const createRecordDiningAudit = async function (data) {
  const headers = await getHeadersAuth();

  return await axios
    .post(`${AUDITSX_BASE_API}/v1/dining/createRecord`, data, {
      headers,
    })
    .then((res) => {
      console.log("Form submitted successfully!", res.data);
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getDiningRecords = async function ({
  deleted,
  from = "",
  to = "",
}) {
  const headers = await getHeadersAuth();

  const apiEndpoint = generateApiEndpoint({
    deleted: deleted,
    from: from,
    to: to,
  });

  try {
    const response = await axios.get(
      `${AUDITSX_BASE_API}/v1/dining/getRecords?${apiEndpoint}`,
      { headers }
    );
    console.log("API Response:", response.data);
    return response;
  } catch (err) {
    console.error("API Error:", err);
    return err;
  }
};

export const updateRecordDining = async function (recordId, data) {
  const headers = await getHeadersAuth();

  return await axios
    .put(`${AUDITSX_BASE_API}/v1/dining/updateRecord/${recordId}`, data, {
      headers,
    })
    .then((res) => {
      console.log("Record updated successfully!", res.data);
      return res;
    })
    .catch((err) => {
      return err;
    });
};
